var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "auth-wrapper auth-v2"
  }, [_c('b-row', {
    staticClass: "auth-inner m-0"
  }, [_c('b-link', {
    staticClass: "brand-logo"
  }, [_c('vuexy-logo'), _c('h2', {
    staticClass: "brand-text text-primary ml-1"
  }, [_vm._v(" PT. BIMA ")])], 1), _c('b-col', {
    staticClass: "d-none d-lg-flex p-0 auth-hero-wrap",
    attrs: {
      "lg": "8"
    }
  }, [_c('section', {
    staticClass: "auth-hero-content w-100 h-100 d-flex flex-column justify-content-between"
  }, [_c('div', {
    staticClass: "auth-hero-top d-flex align-items-center"
  }, [_c('img', {
    staticClass: "mr-1",
    staticStyle: {
      "width": "56px"
    },
    attrs: {
      "src": "/assets/logo-96.png",
      "alt": "Logo"
    }
  }), _c('div', [_c('h3', {
    staticClass: "mb-0 text-white"
  }, [_vm._v("PT. BIMA")]), _c('small', {
    staticClass: "text-white-70"
  }, [_vm._v("ERP System")])])]), _c('div', {
    staticClass: "auth-hero-main"
  }, [_c('h1', {
    staticClass: "auth-hero-title"
  }, [_vm._v(" Akses kembali akun Anda dengan aman. ")]), _c('p', {
    staticClass: "auth-hero-subtitle"
  }, [_vm._v(" Gunakan email terdaftar untuk proses pemulihan akun pada ERP BIMA. ")]), _c('ul', {
    staticClass: "auth-hero-points mb-0"
  }, [_c('li', [_vm._v("Proteksi akun dan akses berbasis peran.")]), _c('li', [_vm._v("Alur reset untuk menjaga keamanan operasional.")]), _c('li', [_vm._v("Dukungan tim IT jika ada kendala autentikasi.")])])]), _c('small', {
    staticClass: "text-white-70"
  }, [_vm._v(" ERP BIMA — Sistem terpadu untuk distribusi dan gudang. ")])])]), _c('b-col', {
    staticClass: "d-flex align-items-center auth-bg px-2 p-lg-5",
    attrs: {
      "lg": "4"
    }
  }, [_c('b-col', {
    staticClass: "px-xl-2 mx-auto",
    attrs: {
      "sm": "8",
      "md": "6",
      "lg": "12"
    }
  }, [_c('b-card-title', {
    staticClass: "mb-1"
  }, [_vm._v(" Lupa Password? 🔒 ")]), _c('b-card-text', {
    staticClass: "mb-2"
  }, [_vm._v(" Masukan email kamu dan kami akan mengirim link untuk reset password ")]), _c('validation-observer', {
    ref: "simpleRules"
  }, [_c('b-form', {
    staticClass: "auth-forgot-password-form mt-2",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validationForm($event);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Email",
      "label-for": "forgot-password-email"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Email",
      "rules": "required|email"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "forgot-password-email",
            "state": errors.length > 0 ? false : null,
            "name": "forgot-password-email",
            "placeholder": "saya@bimeastindonesia.com"
          },
          model: {
            value: _vm.userEmail,
            callback: function callback($$v) {
              _vm.userEmail = $$v;
            },
            expression: "userEmail"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "block": ""
    }
  }, [_vm._v(" Kirim link ")])], 1)], 1), _c('p', {
    staticClass: "text-center mt-2"
  }, [_c('b-link', {
    attrs: {
      "to": {
        name: 'auth-login'
      }
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "ChevronLeftIcon"
    }
  }), _vm._v(" Kembali ke login ")], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }